import React from "react";
import PropTypes from "prop-types";

import Axes from "../axes/index.js";

const ChartWrapper = ({ axes, children, width, height }) => {
  return (
    <svg
      className="chart-wrapper"
      width={width}
      height={height}
      fontFamily={`monospace`}
    >
      <Axes {...axes} />
      {children}
    </svg>
  );
};

ChartWrapper.propTypes = {
  axes: PropTypes.shape({
    xScale: PropTypes.func.isRequired,
    yScale: PropTypes.func.isRequired,
    height: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
    margin: PropTypes.shape({
      top: PropTypes.number,
      right: PropTypes.number,
      bottom: PropTypes.number,
      left: PropTypes.number
    }).isRequired
  }).isRequired,
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired
};

ChartWrapper.defaultProps = {
  width: 500,
  height: 300
};

export default ChartWrapper;
